<div class="bg-white px-4">
    @if (offersStore().entities()) {
        <table
            mat-table
            [dataSource]="dataSource"
            matSort
            matSortActive="title"
            matSortDirection="asc"
            matSortDisableClear>
            <ng-container matColumnDef="id">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    ID
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        <span>
                            {{ element.id }}
                        </span>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="title">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Title
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        <img
                            class="mr-2 size-10"
                            [src]="element.logoUrl"
                            alt="" />
                        <span>
                            {{ element.title }}
                        </span>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="totalCashReward">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Total $
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        <span>
                            {{ element.rewardTotal }}
                        </span>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="totalExpReward">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Total EXP
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        <span>
                            {{ element.expRewardTotal }}
                        </span>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="platform">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Platform
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <span>{{ element.platform | appFlagToString: Platform }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="isPublished">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Published
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <mat-checkbox
                        color="primary"
                        disabled
                        [checked]="element.isPublished"></mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="isActive">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Active
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <mat-checkbox
                        color="primary"
                        disabled
                        [checked]="element.isActive"></mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef></th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <button
                        mat-button
                        [matMenuTriggerFor]="manage">
                        Manage
                    </button>
                    <mat-menu #manage="matMenu">
                        <button
                            mat-menu-item
                            [matMenuTriggerFor]="offer">
                            Offer
                        </button>
                        <button
                            mat-menu-item
                            [matMenuTriggerFor]="goals">
                            Goals
                        </button>
                    </mat-menu>
                    <mat-menu #offer="matMenu">
                        <button
                            mat-menu-item
                            routerLink="/{{
                                ComponentRoutes.offers.offer.replace(':offerId', element.id)
                            }}">
                            <span>Edit offer</span>
                            <mat-icon>edit_square</mat-icon>
                        </button>
                        <button
                            mat-menu-item
                            (click)="copyFullOffer(element.id)">
                            <span>Copy offer</span>
                            <mat-icon>content_copy</mat-icon>
                        </button>
                        @if (!element.publishedAt) {
                            <button
                                mat-menu-item
                                (click)="publishOffer(element.id)">
                                <mat-icon>publish</mat-icon>
                                <span>Publish offer</span>
                            </button>
                        }
                        <button
                            mat-menu-item
                            (click)="archiveOffer(element.id)">
                            <mat-icon class="!text-red-700">warning</mat-icon>
                            <span class="!text-red-700 !font-bold">Archive offer</span>
                        </button>
                        <button
                            mat-menu-item
                            (click)="uploadIdfaCsv()">
                            <mat-icon>upload_file</mat-icon>
                            <span>Upload idfa csv</span>
                        </button>
                        <button
                            mat-menu-item
                            (click)="validateOffer(element.id)">
                            <mat-icon class="!text-blue-500">done_all</mat-icon>
                            <span class="!text-blue-500">Validate offer</span>
                        </button>
                        @if (!element.isActive) {
                            <button
                                mat-menu-item
                                (click)="activateOffer(element.id)">
                                <mat-icon class="!text-green-700">toggle_on</mat-icon>
                                <span class="!text-green-700">Activate offer</span>
                            </button>
                        } @else {
                            <button
                                mat-menu-item
                                (click)="deactivateOffer(element.id)">
                                <mat-icon class="!text-red-500">toggle_off</mat-icon>
                                <span class="!text-red-500">Deactivate offer</span>
                            </button>
                        }
                    </mat-menu>
                    <mat-menu #goals="matMenu">
                        <button
                            mat-menu-item
                            routerLink="/{{
                                ComponentRoutes.offers.offerGoals.replace(':offerId', element.id)
                            }}">
                            <span>Edit goals</span>
                            <mat-icon>edit_square</mat-icon>
                        </button>
                        <button
                            mat-menu-item
                            (click)="copyOfferGoals(element.id)">
                            <span>Copy goals</span>
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupHeader">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header>
                    Active
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ element.bundleId }}
                </td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    }
</div>
